<template>
    <div class="form">
        <a-card size="small" :title="c_title">
            <a-button type="default" @click="handleCancel" slot="extra">返回</a-button>
            <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol"
                :wrapper-col="wrapperCol">
                <a-form-model-item ref="domain" label="领域" prop="domain">
                    <a-select v-if="is_new" v-model="record.domain" style="width: 80px">
                        <a-select-option value="001">前台</a-select-option>
                        <a-select-option value="002">中台</a-select-option>
                        <a-select-option value="003">开放</a-select-option>
                        <a-select-option value="004">基础</a-select-option>
                    </a-select>
                    <span v-else>{{record.domain}}</span>
                </a-form-model-item>

                <a-form-model-item ref="accessmode" label="获取方式" prop="accessmode">
                    <a-select v-if="is_new" v-model="record.accessmode" placeholder="" style="width: 120px" @change="handleModeChange">
                        <a-select-option value="local"> 本地获取 </a-select-option>
                        <a-select-option value="remote"> 远程脚本 </a-select-option>
                    </a-select>
                    <span v-else>{{record.accessmode}}</span>
                </a-form-model-item>

                <a-form-model-item ref="classNameAfter" label="类名" prop="classNameAfter">
                    <a-input :addon-before="record.classNameBefore" v-if="is_new" v-model="record.classNameAfter"  />
                    <span v-else>{{record.classname}}</span>
                </a-form-model-item>

                <a-form-model-item ref="javatext" label="Java脚本代码" prop="javatext">
                    <a-button type="primary" @click="handleJavaText" v-if="is_vue_task" >生成脚本</a-button>
                    <JsonXmlEditor :title="'应用配置：'" :language="'text'" v-model="record.javatext"></JsonXmlEditor>
                </a-form-model-item>

                <a-form-model-item v-show="is_vue_task" :wrapper-col="{ span: 14, offset: 8 }">
                    <a-button type="primary" @click="handleOk" :loading="confirmLoading">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>

        </a-card>
    </div>

</template>
<script>
import JsonXmlEditor from '../../../components/JsonXmlEditor'
const defaultJavaText = 'package com.zl.interceptor.processor.remote;\r\n\r\nimport com.zl.interceptor.processor.AdapterProcessor;\r\n\r\nimport javax.servlet.http.HttpServletRequest;\r\nimport javax.servlet.http.HttpServletResponse;\r\n\r\npublic class ${classname.getsimplename} extends AdapterProcessor {\r\n\r\n    @Override\r\n    public boolean process(HttpServletRequest request, HttpServletResponse response) throws Exception {       \r\n        return false;\r\n    }\r\n\r\n} ';
const m_title = {
    'add_processorClass':'新增处理器配置',
    'detail_processorClass':'查看处理器配置',
    'edit_processorClass':'编辑处理器配置',
};
const classNames = {
    remote:'com.zl.interceptor.processor.remote.',
    local:'com.zl.interceptor.processor.local.'
}
export default {
    data() {
        return {
            c_title:'',
            is_vue_task : true,
            is_new:false,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            rules: {},
            confirmLoading: false,
            formItemLayout:'horizontal',
            
            record:{
                domain:'001',
                accessmode:'local',
                classname:'',
                javatext:'',
                classNameBefore:'',
                classNameAfter:"",
            }
        };
    },
    components:{
        JsonXmlEditor,
    },
    methods: {
        handleOk() {
            console.log(this.record.javatext)
            let that = this;
            that.$refs.ruleForm.validate(valid => {
                if (valid) {
                    that.record.classname = that.record.classNameBefore + that.record.classNameAfter
                    that.confirmLoading = true;
                    const { params } = that.$route;
                    if(params.action == 'edit_processorClass'){
                        that.$store
                            .dispatch({
                                type: "servicekey/processorEditClass",
                                params: that.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                    that.confirmLoading = false;
                                }
                            });
                    }
                    else if(params.action == 'add_processorClass'){
                        that.record.id = '';
                        //新增
                        that.$store
                            .dispatch({
                                type: "servicekey/processorAddClass",
                                params: that.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                }
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleModeChange(){
            this.record.classNameBefore = classNames[this.record.accessmode]

            if(this.record.accessmode == 'remote'){
                this.rules = {
                    accessmode: [
                        { required: true, message: ' 请选择获取方式 ', trigger: 'blur' },
                    ],
                    domain:[
                        { required: true, message: ' 请选择领域 ', trigger: 'blur' },

                    ],
                    classNameAfter:[
                        { required: true, message: ' 请填写类名 ', trigger: 'blur' },
                    ],
                    javatext:[
                        { required: true, message: ' 请填写脚本 ', trigger: 'blur' },
                    ],
                }
            }
            else{
                this.rules = {
                    accessmode: [
                        { required: true, message: ' 请选择获取方式 ', trigger: 'blur' },
                    ],
                    domain:[
                        { required: true, message: ' 请选择领域 ', trigger: 'blur' },

                    ],
                    classNameAfter:[
                        { required: true, message: ' 请填写类名 ', trigger: 'blur' },
                    ],
                }
            }
        },
        handleCancel() {
            this.$router.push({
                path: "processorClass",
                query: {
                    domain:this.record.domain,
                }
            });
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },

        getDetail(query){
            let that = this;
            this.$store.dispatch({
                type: "servicekey/processorQueryClass",
                params: {
                    domain:query.domain,
                    classname:query.classname
                },
                showMsg: false
            }).then((res) => {
                if(res.status == 200 && res.data.success == '1'){
                    let result = res.data.data;
                    that.record = {
                        ...result
                    }
                    that.record.classNameBefore = classNames[result.accessmode];
                    that.record.classNameAfter = result.classname.replace(that.record.classNameBefore,'')
                }
            });
        },
        handleJavaText(){
            if(this.record.classNameAfter != ''){
                this.record.javatext = defaultJavaText.replace('${classname.getsimplename}', this.record.classNameAfter)
            }
            else{
                this.message.info('请先填写类名')
            }
        },

    },

    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.is_new = params.action == "add_processorClass";
        if (!this.is_new) {
            this.getDetail(query)
        }
        else{
            this.resetForm();
            this.record.domain = query.domain
        }
        this.is_vue_task = params.action != 'detail_processorClass'
        this.handleModeChange();
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
